import { render, staticRenderFns } from "./projectReports.vue?vue&type=template&id=31ead2bd&scoped=true&"
import script from "./projectReports.vue?vue&type=script&lang=js&"
export * from "./projectReports.vue?vue&type=script&lang=js&"
import style0 from "./projectReports.vue?vue&type=style&index=0&id=31ead2bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ead2bd",
  null
  
)

export default component.exports